export default {
  exhID: 6554,
  apiURL: 'https://api.exporeg.cn/NewEFPCApi/api',
  apiTestUrl: 'https://eztapi.exporegist.com/EztApi/api',
  tplApiURL: 'https://api.exporeg.cn/NewEFPCApi/api'
}



// WEBPACK FOOTER //
// ./src/config/index.js